module.exports = __webpack_public_path__ + "assets/f6814240d6ce3f4052390e43ececf8c5.png";